// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1AlmY","footer":"ModalUpdate_footer__jSrTT"};